<template>
  <div style="overflow: scroll;background-color:#fff;">
    <div class="user-info">
      <img :src="require('@assets/ic_user_portrait.png')" alt="" />
      <div>
        <div class="user-name">{{ userInfo.patientName }}</div>
        <div style="margin-top:3px;opacity: .65;">{{ userInfo.cardNo }}</div>
      </div>
    </div>
    <div>
      <ph-empty v-if="!detailList.length" />
      <div @click="showPicker = true" class="date-btn">
        <van-icon name="calender-o" />
        {{ time.replace(/(.{4})(.{2})(.{2})/, "$1年$2月$3日") }}
        <van-icon name="arrow-down" />
      </div>
      <div v-for="(item, index) in detailList" :key="index" class="cell">
        <div class="left" style="margin-left:25px;">
          <div style="margin-top:8px;font-weight: bold;font-size:15px;">
            <!-- 便民门诊-王医生 -->
          </div>
          <div style="margin-top:6px;color:#393c4b;font-size: .88rem;">
            {{ item.drugName }}
          </div>
          <div style="margin-top:6px;color:#393c4b;font-size:.8rem;">
            每次用量：{{ item.frequency }}
          </div>
        </div>
        <div class="right" style="width: 35%;margin-right:25px;">
          <div style="margin-top:8px;font-weight: bold;font-size:.88rem;">
            数量：{{ item.drugAmount }}
          </div>
          <div style="margin-top:6px;color:#393c4b;font-size:.8rem;">
            单位：{{ item.dispensingDepartment }}
          </div>
          <div style="margin-top:6px;color:#393c4b;font-size:.75rem;">
            用法：{{ item.drugUsage }}
          </div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="showPicker"
      closeable
      close-icon="close"
      position="bottom"
    >
      <div style="margin: 2rem 1rem 1rem 1rem;">日期选择</div>
      <div class="date-select-list">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="currentItem == index ? 'selected' : ''"
          @click="selectDate(index)"
        >
          {{ item.yearAndMonth.replace(/(.{4})(.{2})(.{2})/, "$1.$2.$3") }}
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      list: [],
      time: "",
      showPicker: false,
      currentItem: 0,
      detailList: [],
      prescriptionNo: "",
      postDic: {},
      userInfo: {}
    };
  },
  computed: {
    ...mapState({
      hospitalInfo: state => state.home.hospitalInfo
    })
  },
  created() {
    this.getUserBaseInfo("1").then(res => {
      this.userInfo = res;
      this.getIllnesslist();
    });
  },
  methods: {
    ...mapActions("users", ["getUserBaseInfo"]),
    getIllnessDetail(groupList) {
      this.detailList = groupList;
    },
    getIllnesslist() {
      this.$http
        .post(this.$api.QUERY_ILLNESS_LIST, {
          functionType: "1",
          startDate: this.$moment()
            .add(-7, "day")
            .format("YYYYMMDD"),
          endDate: this.$moment().format("YYYYMMDD"),
          cardtype: this.userInfo.cardType,
          cardNo: this.userInfo.cardNo
        })
        .then(res => {
          this.list = res;
          if (this.list && this.list.length) {
            const content = this.list[0];
            this.postDic = content;
            this.time = content.yearAndMonth;
            this.getIllnessDetail(content.groupList);
          }
        });
    },
    getDailyListDates() {
      this.$http.post(this.$api.REPORT_DAILYLIST_DATE).then(res => {
        this.dayList = res;
      });
    },
    selectDate(index) {
      this.showPicker = false;
      this.currentItem = index;
      this.getIllnessDetail(this.list[index].groupList);
      this.time = this.list[index].yearAndMonth;
    }
  }
};
</script>

<style lang="less" scoped>
.user-info {
  display: flex;
  align-items: center;
  margin: 0.94rem;
  padding: 0.8rem;
  color: white;
  background-color: #108eee;
  border-radius: 0.25rem;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.07);

  img {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 0.8rem;
    border-radius: 20px;
  }

  .user-name {
    font-weight: bold;
    font-size: 1rem;
  }
}
.date-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 15px 0 15px;
  padding: 0.5rem;
  font-size: 15px;
  border: solid 1px #aaa;
  border-radius: 4px;
}

.date-select-list {
  display: flex;
  flex-wrap: wrap;
  // padding: 1rem;
  // justify-content: space-between;

  .selected {
    color: white;
    background-color: #6596f2;
    border: none;
  }

  div {
    width: 30%;
    margin-bottom: 0.5rem;
    margin-left: 0.5rem;
    color: black;
    line-height: 2rem;
    text-align: center;
    border: solid 1px #dcdcdc;
    border-radius: 0.2rem;
  }
}
.cell {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-bottom: 0.5rem;
  border-bottom: solid #f2f2f2 1px;
}
</style>
